import { ProjectCategoryService } from "../../services/ProjectCategoryService";
import {
    SET_LOADING,
    SET_PROJECT_CATEGORY_LIST,
} from "./types";

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set loading
 */
export const setLoading = (data) => ({
    type: SET_LOADING,
    payload: data
});

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set Project Category list
 */
export const setProjectCategoryList = (data) => ({
    type: SET_PROJECT_CATEGORY_LIST,
    payload: data
});

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to get Project Category list
 */
export const getProjectCategoryList = (successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await ProjectCategoryService.getProjectCategoryList().then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setProjectCategoryList(res?.data[0]));
        successCallback?.();
    }).catch(async (err) => {
        console.log("Project Category list Error: ", err);
        errorCallback?.(err);
    }).finally(() => {
        dispatch(setLoading(false));
    })
};